<template>
  <color
    :background="myColor"
    :class="{
      shadow: !hasBackgroundColor,
      background: hasBackgroundColor,
      rounded
    }"
    class="content-padding"
  >
    <padding :bottom="paddingBottom" :left="paddingLeft" top="space-m">
      <div class="content">
        <slot />
      </div>
    </padding>
  </color>
</template>

<script>
import colors from '@/components/kit/theme'
export default {
  props: {
    color: {
      type: String,
      default: 'transparent'
    },
    inactive: Boolean,
    rounded: Boolean
  },
  computed: {
    hasBackgroundColor() {
      return this.color === 'transparent'
    },
    myColor() {
      return this.inactive ? colors.knownColor('bluegrey-mid') : this.color
    },
    paddingBottom() {
      let paddingVal = ''
      if (!this.hasBackgroundColor) {
        paddingVal = 'space-m'
      }
      if (this.rounded) {
        paddingVal = '19'
      }
      return paddingVal
    },
    paddingLeft() {
      let paddingVal = '16'
      if (!this.hasBackgroundColor) {
        paddingVal = 'space-ml'
      }
      if (this.rounded) {
        paddingVal = 'space-s'
      }
      return paddingVal
    }
  }
}
</script>

<style lang="less" scoped>
@import (reference) '~@/assets/less/main.less';

.content-padding {
  &.color.shadow {
    border-top: 1px solid fade(#006384, 8);
    border-bottom: 1px solid fade(#006384, 8);
  }

  &.shadow {
    .main-shadow;
  }

  &.rounded {
    .lh-box-shadow(
      0 8px 14px 0 rgba(0, 99, 132, 0.12),
      0 0 0 1px rgba(0, 99, 132, 0.04)
    );
    // border: 1px solid fade(@blue-dark, 4);
    border-radius: @border-radius-s;
  }

  &.background {
    ::v-deep .content {
      > h2,
      > h3,
      > p {
        padding: 0 8px;
      }
    }
  }

  ::v-deep .content > * {
    &:not(:last-child) {
      margin-bottom: @space-s;
    }
  }
}
</style>
